import React from "react";
import RadioButton from "./RadioButton";
import PercentInput from "./PercentInput";

const Primaire = ({
  handlePrimaireChange,
  percentChoice,
  setPercentChoice,
  percent,
  onPercentChange,
  formErrors,
  validated,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
      <RadioButton
        id="PrimaireConge1951"
        name="congeOption"
        label="Primaire, par 10 jours (Congé de 19,51%): 2 journées de congé de 4 périodes"
        value="19.51"
        checked={percentChoice === "predefined"}
        onChange={(e) => {
          handlePrimaireChange(e);
          setPercentChoice("predefined");
        }}
      />

      <RadioButton
        id="PrimaireAutre"
        name="congeOption"
        value="autre"
        checked={percentChoice === "other"}
        onChange={() => setPercentChoice("other")}
        label="Autre (veuillez indiquer le pourcentage ci-dessous)"
      />

      {percentChoice === "other" && (
        <div style={{ marginTop: "0.5rem" }}>
          <PercentInput
            value={percent}
            onChange={onPercentChange}
            error={formErrors.percent}
            validated={validated}
          />
        </div>
      )}
    </div>
  );
};

export default Primaire;
